import { render, staticRenderFns } from "./ParamOcorrenciaDestino.vue?vue&type=template&id=4a6a8a36"
import script from "./ParamOcorrenciaDestino.vue?vue&type=script&lang=js"
export * from "./ParamOcorrenciaDestino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports